import * as React from 'react';
import "rxjs/add/observable/from";
import * as classNames from "classnames";
import { withTheme } from '../../../common/withTheme';
import { FooterPropsAndActions } from './Footer';

class FooterCarp extends React.PureComponent<FooterPropsAndActions, any> {

    render() {
        return (
            <footer
                className={classNames(
                    this.props.theme,
                    "container footer mt-5 mb-3"
                )}
            >
                <div className="footer-logo">
                </div>
                <div className="footer-text">
                    <div className="footer-links">
                        <a rel="noopener" href="http://www.carp.gov.au/About-us" target="_blank">About NCCP</a>
                        {" "}
                        <a rel="noopener" href="http://www.carp.gov.au/Contact-us" target="_blank">Contact Us</a>
                        {" "}
                        <a rel="noopener" href="http://www.carp.gov.au/Privacy" target="_blank">Privacy</a>
                        {" "}
                        <a rel="noopener" href="http://www.carp.gov.au/Legal" target="_blank">Legal</a>
                        {" "}
                        <a rel="noopener" href="https://www.feralscan.org.au/" target="_blank">Supported by FeralScan</a>
                    </div>
                    <div className="footer-copyright">
                        © {new Date().getFullYear()} Fisheries Research &amp; Development Corporation
                </div>
                </div>
            </footer>
        );
    }
}

export default withTheme<FooterPropsAndActions>(FooterCarp);